var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 18.333C3.25 17.8267 3.66041 17.4163 4.16667 17.4163H18.8333C19.3396 17.4163 19.75 17.8267 19.75 18.333C19.75 18.8393 19.3396 19.2497 18.8333 19.2497H4.16667C3.66041 19.2497 3.25 18.8393 3.25 18.333ZM12.4167 12.074L17.3337 7.15619C17.6916 6.79822 18.2719 6.79819 18.6299 7.15614C18.9878 7.51404 18.9878 8.09432 18.6299 8.45225L12.1482 14.9347C11.7902 15.2928 11.2098 15.2928 10.8518 14.9348L4.37004 8.45304C4.01214 8.09515 4.0122 7.51477 4.36996 7.15675C4.72789 6.79858 5.30858 6.79829 5.66666 7.15631L10.5833 12.0722V2.74967C10.5833 2.24341 10.9937 1.83301 11.5 1.83301C12.0063 1.83301 12.4167 2.24341 12.4167 2.74967V12.074Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.34c1d69b0bae46a8fd89b37e575b1d9a.svg";
export { ForwardRef as ReactComponent };